export default __webpack_public_path__ + "media/images/blue_heart_sprite-d593ff53852dd5c2468db90a78e95cc8.png";